export const wordOne = [
  {
    id: 1,
    text: "Hate",
    response: "Most crimes are motivated by revenge, prejudice, and hatred.",
  },
  {
    id: 2,
    text: "Alert",
    response: "Being alert is the key to having a good mental presence.",
  },
  {
    id: 3,
    text: "Test",
    response: "Life’s ordeals test us.",
  },
  {
    id: 4,
    text: "Difficult",
    response: "Practice and hard work can triumph over difficult domains.",
  },
  {
    id: 5,
    text: "Situation",
    response: "Investing and saving can improve our financial situation.",
  },
  {
    id: 6,
    text: "Alone",
    response: "Spending time alone helps one to reflect.",
  },
  {
    id: 7,
    text: "Discipline",
    response: "Strong character is rooted in discipline.",
  },
  {
    id: 8,
    text: "Lead",
    response: "Each individual must be the leader of their own time.",
  },
  {
    id: 9,
    text: "Love",
    response: "Love transcends all limitations.",
  },
  {
    id: 10,
    text: "Worry",
    response: "Constant worry restricts clear thinking.",
  },
  {
    id: 11,
    text: "Behave",
    response: "A person's behavior tells a lot about them.",
  },
  {
    id: 12,
    text: "Continue",
    response: "Good work must continue despite obstacles.",
  },
  {
    id: 13,
    text: "Dislike",
    response: "A person who dislikes water suffers from hydrophobia.",
  },
  {
    id: 14,
    text: "Delay",
    response: "Delaying current work hinders future results.",
  },
  {
    id: 15,
    text: "Mad",
    response: "Those who madly desire something end up achieving it.",
  },
  {
    id: 16,
    text: "Anger",
    response: "Anger distorts judgment.",
  },
  {
    id: 17,
    text: "Death",
    response: "Life, birth, and death are part of the cycle of existence.",
  },
  {
    id: 18,
    text: "Need",
    response:
      "The country is in desperate need of population control measures.",
  },
  {
    id: 19,
    text: "Drown",
    response: "Negative thoughts drown us in fear.",
  },
  {
    id: 20,
    text: "Easy",
    response:
      "Bad habits make one an easy target for unfortunate circumstances.",
  },
  {
    id: 21,
    text: "Ahead",
    response:
      "Determination to move ahead despite failure is a sign of courage.",
  },
  {
    id: 22,
    text: "Encourage",
    response: "Easing FDI policy will encourage investment in the country.",
  },
  {
    id: 23,
    text: "System",
    response:
      "One must respect the system of belief and practices of every religion.",
  },
  {
    id: 24,
    text: "Happy",
    response: "It’s better to be a happy monkey than a sad lion.",
  },
  {
    id: 25,
    text: "Discussion",
    response:
      "Sports and healthcare should be major topics of discussion in schools and colleges.",
  },
  {
    id: 26,
    text: "Judge",
    response: "We should not judge people by their appearance.",
  },
  {
    id: 27,
    text: "Women",
    response: "Women are the driving force of the society.",
  },
  {
    id: 28,
    text: "Quick",
    response: "There’s no quick fix to life’s problem.",
  },
  {
    id: 29,
    text: "Idea",
    response: "Ideas leads to Innovation",
  },
  {
    id: 30,
    text: "Gun",
    response: "Gunpowder was first invented in China.",
  },
  {
    id: 31,
    text: "Mistrust",
    response: "Mistrust in own judgement leads to scepticism.",
  },
  {
    id: 32,
    text: "Temper",
    response: "The best remedy for a short temper is a long walk.",
  },
  {
    id: 33,
    text: "Nightmare",
    response: "Dreams conquer nightmares.",
  },
  {
    id: 34,
    text: "Work",
    response:
      "Students and teens should be encouraged to take part-time jobs that provide learning opportunities.",
  },
  {
    id: 35,
    text: "Justice",
    response: "Justice is the motto of the judicial system.",
  },
  {
    id: 36,
    text: "Guilt",
    response: "Guilt makes a heavy burden.",
  },
  {
    id: 37,
    text: "Poetry",
    response: "Peotry is the art of literature.",
  },
  {
    id: 38,
    text: "Blood",
    response: "Blood donation is a great act of kindness.",
  },
  {
    id: 39,
    text: "Luck",
    response: "One must not completely rely upon it.",
  },
  {
    id: 40,
    text: "Drive",
    response: "Our ambition drives us to success.",
  },
  {
    id: 41,
    text: "Ready",
    response: "One must be ready to face life challenges with courage..",
  },
  {
    id: 42,
    text: "Government",
    response: "Stable and honest Government can build a strong nation.",
  },
  {
    id: 43,
    text: "Fear",
    response:
      "The quickest way to conquer fear is to do the very thing we fear.",
  },
  {
    id: 44,
    text: "Noble",
    response: "A noble cause is worth fighting for.",
  },
  {
    id: 45,
    text: "Award",
    response:
      "Param Vir Chakra is the highest Military award given for national bravery.",
  },
  {
    id: 46,
    text: "Care",
    response:
      "Exercising, meditation and proper diet must be the part of our self-care.",
  },
  {
    id: 47,
    text: "End",
    response: "Society must vow together to put an end to violence and hatred.",
  },
  {
    id: 48,
    text: "Home",
    response: "Home is where love resides.",
  },
  {
    id: 49,
    text: "Interest",
    response:
      "A leader should put his personal interests aside and listen to his people.",
  },
  {
    id: 50,
    text: "Joke",
    response: "Jokes lighten up the mood.",
  },
  {
    id: 51,
    text: "Kite",
    response: "Newton’s Law depicts the flying of the kite.",
  },
  {
    id: 52,
    text: "Life",
    response:
      "The quality of our lives is determined by the quality of our thoughts.",
  },
  {
    id: 53,
    text: "Mercy",
    response: "The President has the power to sign mercy petitions.",
  },
  {
    id: 54,
    text: "Neglect",
    response: "Negligence of duty brings faluire.",
  },
  {
    id: 55,
    text: "Old",
    response: "Sanskrit is the oldest language of the world.",
  },
  {
    id: 56,
    text: "Minority",
    response: "Democracy protects the right of Minorities.",
  },
  {
    id: 57,
    text: "Pole",
    response: "Acceleration due to gravity is greater at Pole.",
  },
  {
    id: 58,
    text: "Peace",
    response: "Fear of war maintains global peace.",
  },
  {
    id: 59,
    text: "Quite",
    response: "Quite places are soothing.",
  },
  {
    id: 60,
    text: "Attempt",
    response: "Our every attempt makes us closer to success",
  },
  {
    id: 60,
    text: "Attempt",
    response: "Our every attempt makes us closer to success",
  },
];
